module.exports = __webpack_public_path__ + "img/logo.8551a63d.svg";